"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CotterEnum =
/** @class */
function () {
  function CotterEnum() {}

  CotterEnum.DefaultUSCode = "+1"; // default container ID

  CotterEnum.DefaultContainerID = "cotter-form-container";
  CotterEnum.AssetURL = "https://js.cotter.app";
  CotterEnum.BackendURL = "https://www.cotter.app/api/v0";
  CotterEnum.JSURL = "https://js.cotter.app";
  return CotterEnum;
}();

exports.default = CotterEnum;